var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.00885C10 4.40743 9.77956 5.54549 9.50544 5.54549C9.23131 5.54549 9.01087 4.40743 9.01087 3.00885C9.01087 1.61027 9.23131 0.472212 9.50544 0.472212C9.77956 0.472212 10 1.61027 10 3.00885ZM8.73674 3.00885C8.73674 4.57062 8.10912 5.84106 7.33209 5.84106C6.55506 5.84106 5.9231 4.57062 5.9231 3.00885C5.9231 1.44708 6.55473 0.176637 7.33209 0.176637C8.10945 0.176637 8.73674 1.44708 8.73674 3.00885ZM5.65264 3.00885C5.64797 4.66195 4.38438 6 2.82632 6C1.26559 6 0 4.65699 0 3C0 1.34301 1.26526 0 2.82632 0C3.61035 0 4.32002 0.338761 4.83192 0.886372L4.83225 0.886726C5.33949 1.42867 5.65264 2.17558 5.65264 3C5.65264 3.00319 5.65264 3.00602 5.65264 3.00885Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.bfa561d055285c374061845bb26ac9c3.svg";
export { ForwardRef as ReactComponent };